import React from 'react';
import {ShowGuesser} from "@api-platform/admin";

const AirlineShow = (props) => {
    return (
            <ShowGuesser {...props} />
    );
};

export default AirlineShow;
